// extracted by mini-css-extract-plugin
export default {"cal":"wGei8AzReKaR8wHMeTlC"};